module.exports = __webpack_public_path__ + "img/RegFees-5-webApp.9331cda9.svg";